(function () {
  if (typeof Lenis === 'undefined') return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var lenis = new Lenis({
    duration: 1.2,
    easing: function (t) {
      return Math.min(1, 1.001 - Math.pow(2, -10 * t));
    },
    smoothWheel: true,
    touchMultiplier: 1.5,
    anchors: {
      offset: 96,
    },
  });

  window.rngLenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  document.documentElement.classList.add('lenis', 'lenis-smooth');

  function syncScrollLock() {
    var locked =
      document.body.style.overflow === 'hidden' ||
      document.body.classList.contains('overflow-hidden');

    if (locked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }

  var bodyObserver = new MutationObserver(syncScrollLock);
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['style', 'class'],
  });

  syncScrollLock();
})();
